import React from 'react';
import SegmentedTabs from 'shared/components/ui/SegmentedTabs';
import { UNIT_WORD } from 'features/evals3/editor/EvalSettingsFields';

/**
 * How much of the matching traffic an eval scores: every unit, or a share.
 * A share is chosen by a hash of the unit id, so a unit is always in or
 * always out, and turning the dial down keeps what was already in. Saved in
 * place: it is not what the eval does, so it never makes a version.
 */
const numField = 'h-7 w-20 shrink-0 rounded-md border border-[color:var(--border-default)] bg-[color:var(--surface-base)] px-2 text-[12px] text-[color:var(--text-primary)] outline-none focus:border-[color:var(--border-strong)]';

export default function SamplingField({ target = 'run', value, onChange, readOnly = false }) {
  const pct = value == null ? 100 : Number(value);
  const all = pct >= 100;
  const unit = UNIT_WORD[target] || 'events';
  return (
    <div className="flex flex-wrap items-center gap-2 text-[12px] text-[color:var(--text-secondary)]">
      <SegmentedTabs size="sm" ariaLabel="Sampling" value={all ? 'all' : 'share'}
        onChange={(v) => { if (readOnly) return; onChange(v === 'all' ? 100 : (all ? 10 : pct)); }}
        options={[{ value: 'all', label: `Every ${target}` }, { value: 'share', label: 'A share' }]} />
      {!all && (
        <>
          <input type="number" min={0} max={100} step="any" value={pct} readOnly={readOnly} aria-label="Sample percent" className={numField}
            onChange={(e) => { const n = Number(e.target.value); if (Number.isFinite(n)) onChange(Math.min(100, Math.max(0, n))); }} />
          <span>% of matching {unit}</span>
        </>
      )}
      <span className="text-[color:var(--text-muted)]">{all ? `Every matching ${target} is scored.` : 'The same ones every time.'}</span>
    </div>
  );
}
